import { type RootState } from '../rmsStore'

export default function getChargerReducer (state: RootState): ChargerState {
  return state.chargersReducer
}
